<!--
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2022-08-08 20:46:17
 * @LastEditors: DESKTOP-ROEB53E\caiyangjie 1760178806@qq.com
 * @LastEditTime: 2024-01-03 10:13:07
 * @FilePath: \合联\oms\src\base\common\component\table.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <vxe-table
      border
      stripe
      resizable
      highlight-hover-row
      ref="xTable"
      :id="$route.name"
      :height="
        config.resize === false ? config.height : height || config.height
      "
      :show-overflow="isMethod(config.showOverflow, {}, true)"
      align="center"
      :data="list"
      :scroll-y="{ mode: 'wheel' }"
      :auto-resize="true"
      @checkbox-change="selectAll"
      @checkbox-all="selectAll"
      @checkbox-range-end="selectRange"
      v-bind="config.tableBind"
      :show-footer="config.showFooter || false"
      :footer-method="footerMethod"
      class="mytable-footer"
      :footer-cell-class-name="config.footerCellClassName"
      :sort-config="{ sortMethod: customSortMethod }"
      :tooltip-config="{
        enterable: true,
        contentMethod: config.contentMethod
      }"
      @radio-change="selectRadio"
      :expand-config="config.expandConfig || null"
      :radio-config="config.radioConfig || null"
      :custom-config="{
        checkMethod: isCheckMethod,
        storage: $modal ? false : true
      }"
      :export-config="{ columnFilterMethod }"
      :tree-config="config.treeConfig || null"
      :row-id="config.rowId || ''"
      :checkbox-config="
        config.checkboxConfig || {
          trigger: 'cell',
          highlight: true,
          range: config.treeConfig ? false : true
        }
      "
      :span-method="mergeRowMethod"
      :cell-class-name="config.cellClassName"
      :row-class-name="config.rowClassName"
      :row-style="config.rowStyle"
      :header-cell-class-name="handleHeaderClass"
      :empty-text="$t('NoData')"
    >
      <template v-for="(field, fieldIndex) in fields">
        <TableGroup
          v-if="hasPermission(field.id)"
          :field="fields[fieldIndex]"
          :fields="fields"
          :key="field.rewriteKey ? field.rewriteKey : field.key"
          :config="config"
        >
          <template
            v-for="slot in field.slots"
            #[slot]="{ row, rowIndex, field }"
          >
            <slot
              :name="slot"
              :row="row"
              :rowIndex="rowIndex"
              :field="field"
              :value="row[field.key]"
            ></slot>
          </template>
        </TableGroup>
      </template>
    </vxe-table>
  </div>
</template>
<script>
import TableGroup from "./table-group.vue";
import { VxeTablePropTypes } from "vxe-table";
import { getUserInfo } from "@/api/user";
import { getLetterWidth } from "@/libs/tools.js";
import { optionsApi, optionsCommonApi } from "@/libs/api.request.js";
export default {
  components: {
    TableGroup
  },
  provide() {
    return {
      $table: this
    };
  },
  inject: {
    $page: "$page",
    $modal: {
      default: () => null
    }
  },
  props: {
    list: {
      type: Array
    },
    fields: {
      type: Array,
      default: () => []
    },
    height: {
      type: Number,
      default: 0
    },
    config: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean
    }
  },
  data() {
    return {
      selectList: []
    };
  },
  computed: {
    filterFields() {
      return this.fields.filter(field => {
        return this.isMethodDefault(field.show, {}, true);
      });
    }
  },
  watch: {
    list(val) {
      if (val.length) {
        // console.log(this.$route.meta.id);
        // console.log(
        //   (await getUserInfo()).data.payload.roleAuth.btn[this.$route.meta.id]
        // );
        this.setOperField(val);
      }
    },
    "config.tabName"() {
      this.$refs["xTable"].refreshColumn();
    },
    fields: {
      immediate: true,
      deep: true,
      handler(val) {
        val &&
          val.forEach(field => {
            if (field.methods) {
              if (
                field.methods.list &&
                (field.options && field.only ? !field.options.length : true)
              )
                this.handleMethod({
                  methods: field.methods,
                  name: "list",
                  field
                });
            }
            if (
              field.optionsFn &&
              (field.options ? !field.options.length : true)
            ) {
              optionsApi(field, field.optionsFn);
            }
            // 计算表头宽度
            if (
              field.name &&
              field.type != "seq" &&
              !field.component &&
              !field.copy &&
              (field.minWidth || field.width || field.children)
            ) {
              this.getTableHW(field);
            }
          });
      }
    }
  },
  created() {
    let idx = 0;
    let isFix = "";
    let isAdd = false;
    this.fields.forEach((item, index) => {
      if (item.type === "seq") {
        isAdd = true;
        return false;
      }
      if (item.type === "checkbox" || item.type === "expand") {
        idx = index + 1;
      }
      if (item.fixed === "left") {
        isFix = item.fixed;
      }
      if (!idx && item.type === "btns" && index == 0) {
        idx = index + 1;
      }
      if (item.total) {
        this.config.showFooter = true;
      }
      if (item.children) {
        item.children.forEach(t => {
          if (t.total) {
            this.config.showFooter = true;
          }
        });
      }
    });
    optionsCommonApi(
      this.fields.reduce((a, b) => {
        b.optionsKey && a.set(b, b.optionsKey);
        return a;
      }, new Map())
    );
    if (this.fields.length && !isAdd) {
      this.fields.splice(idx, 0, {
        key: "seq",
        type: "seq",
        align: "center",
        name: "#",
        width: 60,
        fixed: isFix
      });
    }
    this.$nextTick(() => {
      if (!this.config.hideVisible) return;
      let ColumnObject = this.$refs["xTable"]
        .getTableColumn()
        .tableColumn.reduce((a, b) => {
          if (b.property) a[b.property] = b;
          return a;
        }, {});
      this.config.hideVisible &&
        this.config.hideVisible.forEach(t => {
          ColumnObject[t] && this.$refs["xTable"].hideColumn(ColumnObject[t]);
        });
    });
  },
  methods: {
    customSortMethod({ data, sortList }) {
      const { property, order } = sortList[0];
      console.log(sortList[0]);
      let list = [];
      if (order === "asc" || order === "desc") {
        list = data.sort((a, b) => {
          if (/(time|date)/gi.test(property)) {
            return (
              new Date(a[property]).getTime() - new Date(b[property]).getTime()
            );
          }
          return a[property] - b[property];
        });
      }
      if (order === "desc") {
        list.reverse();
      }
      return list;
    },
    footerMethod() {
      if (this.config.footerMethod)
        return this.isMethodDefault(this.configs, {}, []);
      else {
        let list = this.list;
        let fn = t => {
          let num = list.reduce((a, b) => {
            a += !isNaN(~~b[t.key])
              ? parseFloat(String(b[t.key]).replace(",", "") || 0)
              : 0;
            return a;
          }, 0);
          console.log(t, num);
          return num ? parseFloat(num.toFixed(2)) : "-";
        };
        let arr = [];
        this.fields.map((t, i) => {
          if (i == 0) return arr.push(this.$tz("合计"));
          let item = this.list[0];
          if (item) {
            if (t.children) {
              t.children.forEach(c => {
                if (!c.total) return arr.push("-");
                arr.push(fn(c));
              });
              return;
            }
            if (!t.total) return arr.push("-");
            return arr.push(fn(t));
          } else return arr.push("-");
        });
        return [arr];
      }
    },
    columnFilterMethod(data) {
      let isTrue = this.config.exportConfig
        ? this.config.exportConfig(data)
        : true;
      return (!data.column.type || data.column.type == "html") && isTrue;
    },
    handleHeaderClass({ column }) {
      if (column.params && column.params.headerClass) {
        return column.params.headerClass;
      } else {
        if (
          column.children &&
          column.children[0] &&
          column.children[0].params &&
          column.children[0].params.parentHeaderClass
        ) {
          return column.children[0].params.parentHeaderClass;
        }
      }
    },
    // 计算表头的宽度
    getTableHW(field) {
      // console.log(field);
      if (field.children && field.children.length) {
        field.children.forEach(item => {
          this.getTableHW(item);
        });
      } else {
        if (field.minWidth) {
          let mWidth = getLetterWidth(this.isMethod(field.name)) * 2 + 20;
          if (field.header && field.header.copy) {
            mWidth += 20;
          }
          field.minWidth = mWidth > field.minWidth ? mWidth : field.minWidth;
        } else {
          let width = getLetterWidth(this.isMethod(field.name)) * 2 + 20;
          if (field.header && field.header.copy) {
            width += 20;
          }
          field.width = width > field.width ? width : field.width;
        }
      }
    },
    // 操作列长度
    setOperField(list) {
      let field = this.fields.filter(field => {
        return field.type === "btns";
      })[0];
      if (!field) return;
      field.show = () => true;
      if (field && field.type == "btns" && !field.down && !field.noAutoWidth) {
        // 左右内边距边框为16px 左外边距 5px
        let widthNum = 0;
        field.list.forEach(btn => {
          if (!this.$hasPermission(btn.id)) {
            return;
          }
          let btnWidth = 0;
          if (btn.show || btn.afterIcon || btn.icon) {
            for (let i = 0; i < list.length; i++) {
              btnWidth = this.getWidthFun(btn);
              if (
                "show" in btn &&
                !this.isMethodDefault(btn.show, {
                  row: list[i],
                  rowIndex: i,
                  field: field,
                  fields: this.fields
                })
              ) {
                btnWidth = 0;
                continue;
              }
              if (
                btn.afterIcon &&
                this.isMethodDefault(btn.afterIcon, {
                  row: list[i],
                  rowIndex: i,
                  field: field,
                  fields: this.fields
                })
              ) {
                btnWidth += 14;
              }
              if (
                btn.icon &&
                this.isMethod(btn.icon, {
                  row: list[i],
                  rowIndex: i,
                  field: field,
                  fields: this.fields
                })
              ) {
                btnWidth += 14;
              }
              if (btnWidth > 0) {
                break;
              }
            }
            widthNum += btnWidth;
          } else {
            widthNum += this.getWidthFun(btn);
          }
        });
        if (widthNum < 40) {
          field.show = () => false;
        }
        field.width = widthNum + 40;
      }
    },
    // 宽度算法
    getWidthFun(btn) {
      let base = 21;
      if (btn.afterIcon) base += 5;
      if (btn.list && btn.list.length > 0) base += 17;
      return getLetterWidth(this.isMethod(btn.btnName || btn.name), 12) + base;
    },
    hasPermission(id) {
      return this.$hasPermission(id);
    },
    isCheckMethod({ column }) {
      if (column.type || column.title == "订单号码") {
        return false;
      }
      return true;
    },
    handleDropoDown(index, { fields, row, rowIndex }) {
      let btn = fields.list[index];
      this.$page.handleMethod({
        methods: fields.methods,
        name: btn.fnName || "click",
        field: btn,
        row,
        rowIndex,
        fields: fields.list
      });
    },
    mergeRowMethod({ row, _rowIndex, column, visibleData }) {
      const fields = this.config.mergeRows || [];
      const cellValue = row[column.property];
      const field = this.config.mergeRow;
      if ((cellValue || field) && fields.includes(column.property)) {
        const prevRow = visibleData[_rowIndex - 1];
        let nextRow = visibleData[_rowIndex + 1];
        let next = nextRow && nextRow[column.property];
        let next1 = nextRow && nextRow[field];
        let prev = prevRow && prevRow[column.property];
        let prev1 = prevRow && prevRow[field];
        if (
          (!field && prev && prev === cellValue) ||
          (field ? prev1 && prev1 === row[field] : false)
        ) {
          return { rowspan: 0, colspan: 0 };
        } else {
          let countRowspan = 1;

          while (
            (!field && next && next === cellValue) ||
            (field ? next1 === row[field] : false)
          ) {
            nextRow = visibleData[++countRowspan + _rowIndex];
            next = nextRow && nextRow[column.property];
            next1 = nextRow && nextRow[field];
          }
          if (countRowspan > 1) {
            return { rowspan: countRowspan, colspan: 1 };
          }
        }
      }
    },
    fieldCopy({ row, field, value }) {
      if (field.methods && field.methods.render) {
        this.$page.copy(field.methods.render({ row, field, value }));
      } else this.$page.copy(row[field.key]);
    },
    allCopy(key) {
      let list = this.$page.selectAll.length
        ? this.$page.selectAll.map(item => item[key])
        : this.list.map(item => item[key]);
      if (this.config.mergeRows && this.config.mergeRows.includes(key))
        list = Array.from(new Set(list));
      this.$page.copy(list.filter(t => t).join("\n"));
    },
    handleMethod({ methods, name, row, field, fields }) {
      if (methods && methods[name])
        return methods[name].call(this, {
          ...arguments[0],
          row,
          fields,
          field
        });
    },
    handlePlaceholder(item, params) {
      return this.$page.isMethodDefault(
        item.placeholder,
        params,
        "Select " + item.key
      );
    },
    isMethodDefault(methods, params, df) {
      if (typeof methods === "function") return methods.call(this, params);
      return df;
    },
    isMethod(methods, params, df) {
      if (typeof methods === "function") return methods.call(this, params);
      return methods !== undefined ? methods : df;
    },
    selectRadio({ row }) {
      this.selectList = [row];
      this.$emit("checkTable", [row]);
    },
    selectAll(val) {
      this.selectList = val.records;
      this.$emit("checkTable", val.records);
    },
    selectRange(val) {
      this.selectList = val.records;
      this.$emit("checkTable", val.records);
    },
    loadContentMethod({ row }) {
      return new Promise(resolve => {
        let data = {
          row: row,
          resolve
        };
        this.$emit("loadContentMethod", data);
      });
    }
  }
};
</script>
<style>
.mytable-footer .col-red {
  color: red;
}

.mytable-footer .row--hover {
  background-color: #e8f0fd !important;
}
</style>
